enum MedicalTestStatusTypes {
  ORDERED = "Ordered",
  SAMPLE_TAKEN = "Sample Taken",
  INCOMPLETE_RESULT = "Incomplete Result",
  RESULT_READY = "Result Ready",
  CANCELED = "Canceled"
}

export default MedicalTestStatusTypes;
